module.exports = __webpack_public_path__ + "img/far-video.42ee2ea4.svg";